import { ApiService } from './api.service';
import { CookieService } from './cookie.service';
import * as interfaces from 'interfaces';
import { TrackerServiceInstance } from './tracker.service';

export let QuestionServiceInstance: QuestionService | null = null;

export function createQuestionServiceInstance(): void {
  if (!QuestionServiceInstance)
    QuestionServiceInstance = new QuestionService();
}

export class QuestionService extends ApiService {
  private id: string;

  constructor() {
    super();

    this.id = 'QuestionService';

    const token = CookieService.getLocalStorage('token') || CookieService.getCookie('token');

    this.updateRequestHeader('Authorization', token);
  }

  getQuestions(clientId: string, userId: string): Promise<interfaces.QuestionInterface[]> | any {
    const errorIdentifier = `${this.id} -> Get Questions List`;

    return this.get({ endpoint: 'questionsList', path: `?clientId=${clientId}&userId=${userId}` })
      .then((res: any) => {
        const responseData: interfaces.GeneralResponseInterface<interfaces.QuestionInterface> = res.data;

        if (!responseData.data || !responseData.data.length)
          this.reportInvalidResponseError(errorIdentifier, res);

        return responseData.data || [] as interfaces.QuestionInterface[];
      })
      .catch(err => {
        this.reportRequestError(errorIdentifier, err);

        return [] as interfaces.QuestionInterface[];
      });
  }

  createQuestion(data: interfaces.NewQuestionData): Promise<interfaces.QuestionInterface[]> {
    const errorIdentifier = `${this.id} -> Create New Question`;

    return this.post({ endpoint: 'questions' }, data)
      .then((res: any) => {
        const responseData: interfaces.GeneralResponseInterface<interfaces.QuestionInterface> = res.data,
          error: interfaces.ErrorInterface = res.data;

        if (!responseData.data && !error.code)
          this.reportInvalidResponseError(errorIdentifier, res);

        return responseData.data || error;
      })
      .catch(err => {
        this.reportRequestError(errorIdentifier, err);

        return [] as interfaces.QuestionInterface[];
      });
  }

  voteForQuestion(data: { questionId: string; userId: string; amount: number }): Promise<interfaces.VoteInterface[]> {
    const errorIdentifier = `${this.id} -> Vote for the Question`;

    TrackerServiceInstance?.trackEvent('vote', { event_category: 'Votes', questionId: data.questionId, userId: data.userId });
    const user = CookieService.getLocalStorage('user', true);
    data.userId = user.id || data.userId;

    return this.post({ endpoint: 'votes' }, data)
      .then((res: any) => {
        const responseData: interfaces.GeneralResponseInterface<interfaces.VoteInterface> = res.data;

        if (!responseData.data || !responseData.data.length)
          this.reportInvalidResponseError(errorIdentifier, res);

        return responseData.data || [];
      })
      .catch(err => {
        this.reportRequestError(errorIdentifier, err);

        return [] as interfaces.VoteInterface[];
      });
  }
}
